"use client";
import "../../../chunk-MMUBH76A.js";
import { useStore } from "../../stores/useStore.js";
const useModal = () => {
  const isOpen = useStore((state) => state.isOpen);
  const setIsOpen = useStore((state) => state.setIsOpen);
  const openModal = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };
  return { isOpen, openModal, closeModal };
};
export {
  useModal
};
